export default __webpack_public_path__ + "static/slide03-d4bbcf05bd2c56cf584a6454e385c3d2.jpg";